import React from 'react';
import { Star, Quote } from 'lucide-react';
import { reviews } from '../mock';

function Stars() {
  return (
    <div className="flex gap-0.5 text-orange-500">
      {Array.from({ length: 5 }).map((_, i) => (
        <Star key={i} className="h-4 w-4 fill-orange-500" />
      ))}
    </div>
  );
}

export default function Reviews() {
  return (
    <section className="section-fade py-14">
      <div className="mx-auto max-w-7xl px-4 sm:px-6">
        <div className="text-center">
          <p className="font-heading text-sm font-bold uppercase tracking-[0.2em] text-orange-500">Testimonials</p>
          <h2 className="mt-2 font-heading text-4xl font-extrabold text-white sm:text-5xl">Reviews From Verified Buyers</h2>
          <p className="mx-auto mt-3 max-w-2xl text-neutral-400">Real feedback from members who follow our daily predictions.</p>
        </div>
        <div className="mt-12 grid gap-6 md:grid-cols-2 lg:grid-cols-3">
          {reviews.map((r, i) => (
            <div key={i} className="card-dark relative rounded-xl p-6">
              <Quote className="absolute right-5 top-5 h-8 w-8 text-orange-500/20" />
              <Stars />
              <h3 className="mt-3 font-heading text-lg font-bold text-white">{r.title}</h3>
              <p className="mt-2 text-sm leading-relaxed text-neutral-400">“{r.text}”</p>
              <div className="mt-5 flex items-center gap-3 border-t border-[#2e2822] pt-4">
                <div className="flex h-10 w-10 items-center justify-center rounded-full bg-orange-500/15 font-heading text-lg font-bold text-orange-400">{r.name.charAt(0)}</div>
                <div>
                  <p className="text-sm font-semibold text-white">{r.name}</p>
                  <p className="text-xs text-neutral-500">{r.country} · Verified Buyer</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
